export const environment = {
  production: false,
  testing: true,
  development: false,
  // En TEST el navegador debe usar el mismo origen; Nginx deriva /api al backend.
  apiUrl: '/api',
  sseStreamUrl: '/api/sse/events',
  // En TEST, Gestión Ticket se accede directamente en el servidor de pruebas.
  ticketWebUrl: 'http://192.168.7.70:8080/sgr',
};
